import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import Utils from '../../../utils/Utils';
import { converter } from '../../../helpers/converter';
import { GetRegion } from '../../../constants';
import * as metricsActions from '../../../action-creators/metrics';

import get from 'lodash/get';
import { getCounterValidEmail } from '../../../action-creators/ip_telmex';
import { withRouterListener } from 'utils/hocs/withRouterListener';

const classButtonInactive = 'btn btn-default close-modal btn-block';
class ModalEstRentaSuccess extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.handleClick = this.handleClick.bind(this);
    // localStorage.removeItem('aE');
    // Set Metrics
    props.setMetricsEvent({
      type: 'executor',
      success: true,
    });

  }

  closeModal() {
    const { group_id } = this.props.queryParams;
    const redirect = () => {
      if (group_id) {
        return window.location.replace(`${ClaroUrlBuilder.card(GetRegion(), group_id)}?forced`);
      }
      this.props.closeModal('EstRentaSuccess');
    };
    redirect();
  }

  handleClick = (next) => {
    const userMailValidation = JSON.parse(
      this.props.metadata.user_mail_validation
    );
    const counter = get(userMailValidation, 'mexico.limit');
    this.props
      .getCounterValidEmail(counter, next.bind(this))
      .then(wait => !wait && next());
  }

  onPlay = () => {
    const params = this.props.queryParams;
    const isMobile = Utils.MobileCheck();
    if (isMobile) {
      this.props.closeModal('EstRentaSuccess');
      return this.props.history.navigate(
        `/${GetRegion()}/devices?runplayerinapp&group_id=${params.group_id}`
      );
    }
    const redirect = () => {
      const formContent = params.group_id;
      const playerUrl = params.player_url;
      if (formContent && playerUrl) {
        return window.location.replace(decodeURIComponent(playerUrl));
      }

      window.location = ClaroUrlBuilder.home();
    };

    redirect();
    // this.sendAnalytics(params, redirect);
  }

  onDownload = () => {
    const { user } = this.props;
    const {group_id: groupId, titleUri } = this.props.queryParams;
    const link = `/${user.region}/vcard/${titleUri}/${groupId}`;
    this.props.history.navigate(link);
  };

  renderPlayDownloadButton() {
    const btnButtonsClass =
      'col-lg-3 col-md-3 col-sm-5 col-xs-5 padding-top-05';

    if (this.props.noShowPlayDownload) {
      return;
    }

    return (
      <div className="footer-modal-button flex-end">
        <div className={btnButtonsClass}>
          <Button className={classButtonInactive} onClick={() => this.handleClick(this.onPlay)}>
            {converter.convertApaUnicode(
              this.props.translations,
              'detail_play',
              'Ver'
            )}
            {' '}
            <i className="fa fa-play" />
          </Button>
        </div>
        <div className={btnButtonsClass}>
          <Button className={classButtonInactive} onClick={() => this.handleClick(this.onDownload)}>
            {converter.convertApaUnicode(
              this.props.translations,
              'download_button',
              'Descargar'
            )}
            {' '}
            <i className="fa fa-download" />
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal show>
        <Modal.Header>
          <Button className="close close-modal" onClick={() => this.handleClick(this.closeModal)}>
            x
          </Button>
          <h2 className="modal-title">{this.props.title}</h2>
        </Modal.Header>
        <Modal.Body className="text-center success">
          <i className="fa text-center fa-3x fa-check" />
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </Modal.Body>
        <Modal.Footer>
          {this.renderPlayDownloadButton()}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  router: state.routing,
  user: state.user,
  metadata: state.metadata,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  },
  getCounterValidEmail(count, next) {
    return dispatch(getCounterValidEmail(count, next));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouterListener(ModalEstRentaSuccess)
);
